import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import Typography from '@/components_new/Typography.vue'

import FennekImg from './fennec.webp'
import SampleVideo from './sample-video.webm?file'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstreamWrapper',
  props: {
    isVisible: { type: Boolean },
    isOverlayVisible: { type: Boolean },
    secondsLeft: {},
    onResume: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.banner)
    }, [
      _createElementVNode("video", {
        id: "google-instream-player",
        playsinline: "",
        "webkit-playsinline": "true",
        class: _normalizeClass(_ctx.$style.player)
      }, [
        _createElementVNode("source", { src: _unref(SampleVideo) }, null, 8, _hoisted_1)
      ], 2),
      _createElementVNode("div", {
        id: "google-instream-banner",
        class: _normalizeClass(_ctx.$style.adContainer)
      }, null, 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content)
    }, [
      _createElementVNode("img", {
        src: _unref(FennekImg),
        alt: "fennec",
        class: _normalizeClass(_ctx.$style.icon)
      }, null, 10, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.info)
      }, [
        _createVNode(Typography, {
          accent: "",
          responsive: "",
          size: "s",
          class: _normalizeClass(_ctx.$style.text)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tr('instreamWrapper.info')), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(Typography, {
          responsive: "",
          size: "xs",
          class: _normalizeClass(_ctx.$style.subtext)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tr('instreamWrapper.ad')) + " ", 1),
            (_ctx.secondsLeft > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.secondsLeft) + " " + _toDisplayString(_ctx.$tr('instreamWrapper.sec')), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"])
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.continueOverlay, { [_ctx.$style.visible]: _ctx.isOverlayVisible }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onResume && _ctx.onResume(...args)))
    }, null, 2)
  ], 64))
}
}

})